import React, { useEffect, useState } from "react";
import DecorativeSquares from "../ui/DecorativeSquares";
import { useNavigate, useParams } from "react-router-dom";
import Initials from "../Initials/Initials";
import { FiPhoneCall } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Paysheet from "./Paysheet";
import { getCustomerRecords } from "../../redux/thunks/customerRecordThunk";
import PaymentShimmer from "../Preloader/PaymentShimmer";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../../utils/urlCrypto";

const Payment = () => {
  const { customer_id } = useParams();
  const customerId = decryptId(customer_id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [BalanceType, setBalanceType] = useState(null);
  const [Curr, setCurr] = useState("");
  const [amountDu, setAmountDu] = useState(null);
  const { isCustmerLoading } = useSelector((state) => state.customerRecords);
  const [customerData, setCustomerData] = useState(null);
  useEffect(() => {
    const payload = {
      service_provider_customer_id: customerId,
    };
    dispatch(getCustomerRecords(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of getting the customer records is :", res.data);
        const getCustomerData = res.data;
        setCustomerData(getCustomerData);
        const getbalanceType = res.data?.balance_type;
        setBalanceType(getbalanceType);
        const amountDue = res.data?.amount_due;
        setAmountDu(amountDue);
        const getCurr = res.data?.currency_symbol;
        // console.log("the res of currency is :", getCurr);
        setCurr(getCurr);
      });
  }, [dispatch, customerId]);
  const handleGoBack = () => {
    navigate(`/customers-detail/${encryptId(customerId)}`);
  };

  if (!customerData) {
    return <PaymentShimmer />;
  }

  return (
    <>
      <section className="space-y-6 relative max-w-7xl mx-auto px-4 py-6">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={handleGoBack}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Payment history
          </h1>
        </div>
        <div className="px-0 md:px-4 mt-8 space-y-4">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl  p-2 shadow-sm">
            <div className="flex justify-between">
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <Initials initial={customerData.initials} />
                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {customerData.customer_name}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                    <FiPhoneCall size={10} />+{customerData.country_code}{" "}
                    {customerData.contact_no}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`mt-6 rounded-2xl p-6 text-white text-center shadow-md ${
                BalanceType === "advance"
                  ? "bg-gradient-to-br from-green-400 to-green-300"
                  : "bg-gradient-to-br from-[#FF6943] to-[#ff8a6d]"
              }`}
            >
              <h1 className="text-3xl font-bold tracking-tight">
                {Curr}
                {Number(Math.abs(amountDu)).toFixed(2)}
              </h1>
              <p className="mt-1 text-sm opacity-90">
                {BalanceType === "advance" ? (
                  <span className="text-green-900 font-bold">
                    Surplus Amount
                  </span>
                ) : (
                  <span className="text-red-900 font-bold">Amount Due</span>
                )}
              </p>
            </div>
            <div className="border-t border-gray-100 mt-4" />

            <div className="grid  grid-cols-3 divide-y divide-y-0 divide-x divide-gray-100">
              {/* Total Amount */}
              <div className="py-4 text-center">
                <h3 className="font-semibold text-base text-[#191919]">
                  {Curr}
                  {Number(customerData.total_amount).toFixed(2)}
                </h3>
                <p className="text-sm text-[#969495]">Total Amount</p>
              </div>

              {/* Payment Received */}
              <div className="py-4 text-center">
                <h3 className="font-semibold text-base text-[#191919]">
                  {Curr}
                  {Number(customerData.payment_received).toFixed(2)}
                </h3>
                <p className="text-sm text-[#969495]">Payment Received</p>
              </div>

              {/* Total Tiffins */}
              <div className="py-4 text-center">
                <h3 className="font-semibold text-base text-[#191919]">
                  {customerData.total_tiffins_consumed}
                </h3>
                <p className="text-sm text-[#969495]">Total Tiffins Consumed</p>
              </div>
            </div>

            <div className="border-t border-gray-100" />

            <div>
              <Paysheet customerId={customerId} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Payment;
